import React from 'react';
import { Table, Badge, Button, Card, Form } from 'react-bootstrap';
import SearchableSelect from '../common/SearchableSelect';

const ReconciliationDashboard = ({ 
  accounts, 
  selectedAccount, 
  setSelectedAccount, 
  selectedYear,
  setSelectedYear,
  monthlyStatus, 
  onStart 
}) => {
  const months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 5 }, (_, i) => currentYear - i);

  const getStatusBadge = (status) => {
    switch (status) {
      case 'Reconciled': return <Badge variant="success"><i className="fas fa-check-circle mr-1"></i> Reconciled</Badge>;
      case 'Ready': return <Badge variant="primary"><i className="fas fa-play-circle mr-1"></i> Ready</Badge>;
      default: return <Badge variant="light" className="text-muted border">Pending</Badge>;
    }
  };

  return (
    <Card className="shadow-sm border-0">
      <Card.Body className="p-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div>
            <h5 className="mb-1 font-weight-bold">Monthly Reconciliation Status</h5>
            <p className="text-muted small mb-0">Select an account and year to view monthly snapshots.</p>
          </div>
          <div className="d-flex align-items-center">
            <Form.Control 
              as="select" size="sm" className="border-info mr-2"
              style={{ width: '100px' }}
              value={selectedYear} 
              onChange={e => setSelectedYear(parseInt(e.target.value))}
            >
              {years.map(y => <option key={y} value={y}>{y}</option>)}
            </Form.Control>
            <div style={{ width: '250px' }}>
              <SearchableSelect
                options={accounts.map(acc => ({ value: acc._id, label: acc.name, sublabel: acc.type }))}
                value={selectedAccount} 
                onChange={e => setSelectedAccount(e.target.value)}
                placeholder="-- Select Account --"
              />
            </div>
          </div>
        </div>

        <Table responsive hover className="mb-0">
          <thead className="bg-light">
            <tr>
              <th className="border-0 small text-uppercase py-3" style={{width: '20%'}}>Month</th>
              <th className="border-0 small text-uppercase py-3" style={{width: '20%'}}>Status</th>
              <th className="border-0 small text-uppercase py-3" style={{width: '30%'}}>Snapshot Details</th>
              <th className="border-0 small text-uppercase py-3 text-right" style={{width: '30%'}}>Action</th>
            </tr>
          </thead>
          <tbody>
            {months.map((name, index) => {
              const mData = monthlyStatus?.months?.find(m => m.month === index + 1);
              const isDone = mData?.status === 'Reconciled';
              const isReady = mData?.status === 'Ready';

              return (
                <tr key={name}>
                  <td className="align-middle font-weight-bold">{name} {selectedYear}</td>
                  <td className="align-middle">
                    {getStatusBadge(mData?.status)}
                  </td>
                  <td className="align-middle small">
                    {isDone ? (
                      <div className="text-muted">
                        Ending: <strong>${mData.reconciliation.endingBalance?.toFixed(2)}</strong><br/>
                        <span style={{fontSize: '0.7rem'}}>Closed on {new Date(mData.reconciliation.statementEndingDate).toLocaleDateString()}</span>
                      </div>
                    ) : (
                      mData?.statement ? (
                        <div className="text-primary font-weight-bold">
                          Statement found: ${mData.statement.endingBalance?.toFixed(2)}
                        </div>
                      ) : <span className="text-muted">No statement uploaded</span>
                    )}
                  </td>
                  <td className="align-middle text-right">
                    {isDone ? (
                      <Button variant="outline-secondary" size="sm">
                        View Report
                      </Button>
                    ) : (
                      <Button 
                        variant={isReady ? "primary" : "outline-primary"} 
                        size="sm"
                        onClick={() => onStart({ ...mData, year: selectedYear })}
                        disabled={!selectedAccount}
                      >
                        {isReady ? 'Start Reconciling' : 'Manual Reconcile'}
                      </Button>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
};

export default ReconciliationDashboard;
